export const countriesSongsMap = {
	'Aruba':{'countryName':'Aruba','youtubeId':'i1vE0J99zt0'},
	'Afghanistan':{'countryName':'Afghanistan','youtubeId':'Gs9y-P0FdOo'},
	'Anguilla':{'countryName':'Anguilla','youtubeId':'-quXwf9hysE'},
	'Angola':{'countryName':'Angola','youtubeId':'KgppoKTseoE'},
	'Åland Islands':{'countryName':'Åland Islands','youtubeId':'XGKldSW4WrU'},
	'Albania':{'countryName':'Albania','youtubeId':'L9rGGtSaMjk'},
	'Andorra':{'countryName':'Andorra','youtubeId':'kcisPq1NXhc'},
	'United Arab Emirates':{'countryName':'United Arab Emirates','youtubeId':'A6YNljzz-M4'},
	'Argentina':{'countryName':'Argentina','youtubeId':'yqBC3l7i7dk'},
	'Armenia':{'countryName':'Armenia','youtubeId':'nxhMfBYvFmA'},
	'American Samoa':{'countryName':'American Samoa','youtubeId':'5NHmITMZYis'},
	// "French Southern Territories":{"countryName":"French Southern Territories","youtubeId":"CXVk3SVfIIU"},
	'Antigua and Barbuda':{'countryName':'Antigua and Barbuda','youtubeId':'KgCeA0ayM9E'},
	'Australia':{'countryName':'Australia','youtubeId':'Dqtkckl6s5Y'},
	'Austria':{'countryName':'Austria','youtubeId':'AQfp888IRpo'},
	'Azerbaijan':{'countryName':'Azerbaijan','youtubeId':'gmsXFARCJqM'},
	'Burundi':{'countryName':'Burundi','youtubeId':'H6aG6RKUhGE'},
	'Belgium':{'countryName':'Belgium','youtubeId':'d9u_Ituu2Q8'},
	'Benin':{'countryName':'Benin','youtubeId':'t3gZ2SccaG0'},
	'Bonaire, Sint Eustatius and Saba':{'countryName':'Bonaire, Sint Eustatius and Saba','youtubeId':'ioCd2YjHXoI'},
	'Burkina Faso':{'countryName':'Burkina Faso','youtubeId':'osI6Dajg3_8'},
	'Bangladesh':{'countryName':'Bangladesh','youtubeId':'2d4IyxrrzdU'},
	'Bulgaria':{'countryName':'Bulgaria','youtubeId':'aEQ57nuXe78'},
	'Bahrain':{'countryName':'Bahrain','youtubeId':'qNQQX1L_2QM'},
	'Bahamas':{'countryName':'Bahamas','youtubeId':'r9_-JeJIXG0'},
	'Bosnia and Herzegovina':{'countryName':'Bosnia and Herzegovina','youtubeId':'OfqxCJfW4t4'},
	'Belarus':{'countryName':'Belarus','youtubeId':'KUnY19OnkJc'},
	'Belize':{'countryName':'Belize','youtubeId':'4Emkc4r_V8E'},
	'Bermuda':{'countryName':'Bermuda','youtubeId':'H89-tx3yee0'},
	'Bolivia':{'countryName':'Bolivia','youtubeId':'JCSCJfcBabk'},
	'Brazil':{'countryName':'Brazil','youtubeId':'2HnEud_VRYY'},
	'Barbados':{'countryName':'Barbados','youtubeId':'83-Tmu595g8'},
	'Brunei Darussalam':{'countryName':'Brunei Darussalam','youtubeId':'iUChRegvHIA'},
	'Bhutan':{'countryName':'Bhutan','youtubeId':'QBzf5Pp5dl0'},
	'Bouvet Island':{'countryName':'Bouvet Island','youtubeId':'_JArlaYr2GM'},
	'Botswana':{'countryName':'Botswana','youtubeId':'rqqfYi-1OUg'},
	'Central African Republic':{'countryName':'Central African Republic','youtubeId':'vPyNODbaMlo'},
	'Canada':{'countryName':'Canada','youtubeId':'kRPGPAnPNa8'},
	'Switzerland':{'countryName':'Switzerland','youtubeId':'ZfDpRzN2SBI'},
	'Chile':{'countryName':'Chile','youtubeId':'f9IeLVWFOS0'},
	'China':{'countryName':'China','youtubeId':'IeMFXiEq_ow'},
	'Côte d\'Ivoire':{'countryName':'Côte d\'Ivoire','youtubeId':'O4JnxkVmROE'},
	'Cameroon':{'countryName':'Cameroon','youtubeId':'k3IqrHoYw4g'},
	'Democratic Republic of the Congo':{'countryName':'Democratic Republic of the Congo','youtubeId':'Il8bLbcQpTw'},
	'Congo':{'countryName':'Congo','youtubeId':'eFyNBz5DSGQ'},
	'Cook Islands':{'countryName':'Cook Islands','youtubeId':'FrYeM-tHsXc'},
	'Colombia':{'countryName':'Colombia','youtubeId':'7co4DMeXjAE'},
	'Comoros':{'countryName':'Comoros','youtubeId':'j1hAmNRHAT8'},
	'Cabo Verde':{'countryName':'Cabo Verde','youtubeId':'uaCAVYUxpKY'},
	'Costa Rica':{'countryName':'Costa Rica','youtubeId':'kyQjSwIuSz4'},
	'Cuba':{'countryName':'Cuba','youtubeId':'JGT9Zwk892k'},
	'Curaçao':{'countryName':'Curaçao','youtubeId':'LDXRuZxU30E'},
	'Christmas Island':{'countryName':'Christmas Island','youtubeId':'bXFKDL30GbY'},
	'Cayman Islands':{'countryName':'Cayman Islands','youtubeId':'p_fWLhbp_Vs'},
	'Cyprus':{'countryName':'Cyprus','youtubeId':'EthlIFYV6og'},
	'Czechia':{'countryName':'Czechia','youtubeId':'xg3STXnurGY'},
	'Germany':{'countryName':'Germany','youtubeId':'GmaC9qop5bU'},
	'Djibouti':{'countryName':'Djibouti','youtubeId':'VGpZWnViNY4'},
	'Dominica':{'countryName':'Dominica','youtubeId':'QOKZuj0W9M8'},
	'Denmark':{'countryName':'Denmark','youtubeId':'oSwV-DJivQU'},
	'Dominican Republic':{'countryName':'Dominican Republic','youtubeId':'AcUj2v9jKs0'},
	'Algeria':{'countryName':'Algeria','youtubeId':'sLy650hukPc'},
	'Ecuador':{'countryName':'Ecuador','youtubeId':'a179MZiB7TI'},
	'Egypt':{'countryName':'Egypt','youtubeId':'uuFES8o0-aQ'},
	'Eritrea':{'countryName':'Eritrea','youtubeId':'8RQC04GQI-0'},
	'Western Sahara':{'countryName':'Western Sahara','youtubeId':'CMmEG7iYrRg'},
	'Spain':{'countryName':'Spain','youtubeId':'GWCldYPEsl4'},
	'Estonia':{'countryName':'Estonia','youtubeId':'vGpdbgf26t8'},
	'Ethiopia':{'countryName':'Ethiopia','youtubeId':'BrzZk5RuzUg'},
	'Finland':{'countryName':'Finland','youtubeId':'QGNdTH53YxM'},
	'Fiji':{'countryName':'Fiji','youtubeId':'gLn4NkuPsJw'},
	'Falkland Islands':{'countryName':'Falkland Islands','youtubeId':'tUVF_Tan29g'},
	'France':{'countryName':'France','youtubeId':'buHFjhcq2IE'},
	'Faroe Islands':{'countryName':'Faroe Islands','youtubeId':'n_uz28txGNA'},
	'Micronesia':{'countryName':'Micronesia','youtubeId':'2FAkFHcDBWE'},
	'Gabon':{'countryName':'Gabon','youtubeId':'mBueiMr3GFE'},
	'United Kingdom of Great Britain and Northern Ireland':{'countryName':'United Kingdom of Great Britain and Northern Ireland','youtubeId':'G9eK9fWUb3s'},
	'Georgia':{'countryName':'Georgia','youtubeId':'wxvkzbArNf4'},
	// 'Guernsey':{'countryName':'Guernsey','youtubeId':''},
	'Ghana':{'countryName':'Ghana','youtubeId':'QLwXmWHJxR8'},
	'Guinea':{'countryName':'Guinea','youtubeId':'_2aBxpl9H-o'},
	'Guadeloupe':{'countryName':'Guadeloupe','youtubeId':'PcRM6zvrApI'},
	'Gambia':{'countryName':'Gambia','youtubeId':'6HVpGTRWQFo'},
	'Guinea-Bissau':{'countryName':'Guinea-Bissau','youtubeId':'JPJyW0559bk'},
	'Equatorial Guinea':{'countryName':'Equatorial Guinea','youtubeId':'3_pA6qqCcyM'},
	'Greece':{'countryName':'Greece','youtubeId':'A0Jg5StzLfE'},
	'Grenada':{'countryName':'Grenada','youtubeId':'qPFJatrxpxY'},
	'Greenland':{'countryName':'Greenland','youtubeId':'SQKknk1O7Nk'},
	'Guatemala':{'countryName':'Guatemala','youtubeId':'1O8mA565IGg'},
	'French Guiana':{'countryName':'French Guiana','youtubeId':'THRMbYVtB7A'},
	'Guam':{'countryName':'Guam','youtubeId':'31ajga4jw-E'},
	'Guyana':{'countryName':'Guyana','youtubeId':'rK6HQ-4lI8w'},
	'Hong Kong':{'countryName':'Hong Kong','youtubeId':'bGdfHK42JR0'},
	'Heard Island and McDonald Islands':{'countryName':'Heard Island and McDonald Islands','youtubeId':'8jPjTiz1md4'},
	'Honduras':{'countryName':'Honduras','youtubeId':'lVqwaMVI4Hw'},
	'Croatia':{'countryName':'Croatia','youtubeId':'xDyqYTzB6PQ'},
	'Haiti':{'countryName':'Haiti','youtubeId':'TXOOqj_wUpE'},
	'Hungary':{'countryName':'Hungary','youtubeId':'cTA_y9Aq6XU'},
	'Indonesia':{'countryName':'Indonesia','youtubeId':'Rc2dG7uMlhA'},
	'Isle of Man':{'countryName':'Isle of Man','youtubeId':'vzJVObTjGx8'},
	'India':{'countryName':'India','youtubeId':'lZi3fwP09zw'},
	// 'British Indian Ocean Territory':{'countryName':'British Indian Ocean Territory','youtubeId':''},
	'Ireland':{'countryName':'Ireland','youtubeId':'yTxlCR7B518'},
	'Iran':{'countryName':'Iran','youtubeId':'9fA9IpeWZUI'},
	'Iraq':{'countryName':'Iraq','youtubeId':'A9hyl6CaAMU'},
	'Iceland':{'countryName':'Iceland','youtubeId':'CDKy-vf0JDc'},
	'Israel':{'countryName':'Israel','youtubeId':'lMwSlp7I7IQ'},
	'Italy':{'countryName':'Italy','youtubeId':'FM_Rre3gOXs'},
	'Jamaica':{'countryName':'Jamaica','youtubeId':'dMdaY0j4bMI'},
	// 'Jersey':{'countryName':'Jersey','youtubeId':''},
	'Jordan':{'countryName':'Jordan','youtubeId':'_ng4QjClE6c'},
	'Japan':{'countryName':'Japan','youtubeId':'S2Vanclvh3Q'},
	'Kazakhstan':{'countryName':'Kazakhstan','youtubeId':'UamvtFPhFoU'},
	'Kenya':{'countryName':'Kenya','youtubeId':'-UI8l7N-76I&t=8s'},
	'Kyrgyzstan':{'countryName':'Kyrgyzstan','youtubeId':'b-x47JRtf0M&t=9s'},
	'Cambodia':{'countryName':'Cambodia','youtubeId':'oBk64xStymM&t=1s'},
	'Kiribati':{'countryName':'Kiribati','youtubeId':'ZJr_UpEf7Jo'},
	'Saint Kitts and Nevis':{'countryName':'Saint Kitts and Nevis','youtubeId':'F0tuMjP2ufo'},
	'South Korea':{'countryName':'South Korea','youtubeId':'AybSpW2GveQ'},
	'Kuwait':{'countryName':'Kuwait','youtubeId':'BH6wMbJiFnc'},
	'Lao People\'s Democratic Republic':{'countryName':'Lao People\'s Democratic Republic','youtubeId':'x9wOdvR-mt8'},
	'Lebanon':{'countryName':'Lebanon','youtubeId':'A8XWF_682is'},
	'Liberia':{'countryName':'Liberia','youtubeId':'SKfU4Dz2V4s'},
	'Libya':{'countryName':'Libya','youtubeId':'opd-VnY_d94'},
	'Saint Lucia':{'countryName':'Saint Lucia','youtubeId':'aLb-rm3FfQE'},
	'Liechtenstein':{'countryName':'Liechtenstein','youtubeId':'hncmf1CoUbg'},
	'Sri Lanka':{'countryName':'Sri Lanka','youtubeId':'JslPiA9mPls'},
	'Lesotho':{'countryName':'Lesotho','youtubeId':'M5JDpoRumW8'},
	'Lithuania':{'countryName':'Lithuania','youtubeId':'SDQQcGlYdYk'},
	'Luxembourg':{'countryName':'Luxembourg','youtubeId':'mDCPI-K43XE'},
	'Latvia':{'countryName':'Latvia','youtubeId':'SCfX2gGohjU'},
	'Saint Martin (French part)':{'countryName':'Saint Martin (French part)','youtubeId':'tYIjkj42SyU'},
	'Morocco':{'countryName':'Morocco','youtubeId':'tQco3nyO6PU'},
	'Moldova':{'countryName':'Moldova','youtubeId':'f8k-es49Er0'},
	'Madagascar':{'countryName':'Madagascar','youtubeId':'74Cq_JUYrRE'},
	'Mexico':{'countryName':'Mexico','youtubeId':'cDAjDDdPqvA'},
	'Marshall Islands':{'countryName':'Marshall Islands','youtubeId':'woGxesFbEac'},
	'Macedonia':{'countryName':'Macedonia','youtubeId':'HJsUBZ9nRns'},
	'Mali':{'countryName':'Mali','youtubeId':'glZ7LTrfYc0'},
	'Malta':{'countryName':'Malta','youtubeId':'8q-0jciioAE'},
	'Myanmar':{'countryName':'Myanmar','youtubeId':'M4JC3GZ0QsY'},
	'Montenegro':{'countryName':'Montenegro','youtubeId':'GPtPjMdtofk'},
	'Mongolia':{'countryName':'Mongolia','youtubeId':'TW-fU8uMdzI'},
	'Northern Mariana Islands':{'countryName':'Northern Mariana Islands','youtubeId':'EIjW-MaIUEg'},
	'Mozambique':{'countryName':'Mozambique','youtubeId':'U-E97e5Owl0'},
	'Mauritania':{'countryName':'Mauritania','youtubeId':'yEvaK-uXj_A'},
	'Montserrat':{'countryName':'Montserrat','youtubeId':'b69Q8HsDL6k'},
	'Martinique':{'countryName':'Martinique','youtubeId':''},
	'Mauritius':{'countryName':'Mauritius','youtubeId':'MfjKMA-tgQ0'},
	'Malawi':{'countryName':'Malawi','youtubeId':'NQM-9gJvHKQ'},
	'Malaysia':{'countryName':'Malaysia','youtubeId':'2alzBDgkAeI'},
	'Mayotte':{'countryName':'Mayotte','youtubeId':'n8aXr_--dYU'},
	'Namibia':{'countryName':'Namibia','youtubeId':'CGuHeS7MgBY'},
	'New Caledonia':{'countryName':'New Caledonia','youtubeId':'qzFzZjhzcyk'},
	'Niger':{'countryName':'Niger','youtubeId':'4I9ZDf9Vksg'},
	'Nigeria':{'countryName':'Nigeria','youtubeId':'avPeagYhbgo'},
	'Nicaragua':{'countryName':'Nicaragua','youtubeId':'iwFLHrOEM1I'},
	'Niue':{'countryName':'Niue','youtubeId':'5qrKn8r5mjo'},
	'Netherlands':{'countryName':'Netherlands','youtubeId':'uIg9VaMBi9o'},
	'Norway':{'countryName':'Norway','youtubeId':'VRS6cbLOrPQ'},
	'Nepal':{'countryName':'Nepal','youtubeId':'cZophCR3rmo'},
	'New Zealand':{'countryName':'New Zealand','youtubeId':'RYdfQvZrakM'},
	'Oman':{'countryName':'Oman','youtubeId':'DkDYlNfBSgw'},
	'Pakistan':{'countryName':'Pakistan','youtubeId':'38UUz15fEzo'},
	'Panama':{'countryName':'Panama','youtubeId':'lNsnWz1U_D0'},
	'Peru':{'countryName':'Peru','youtubeId':'pG1f7B4zOVM'},
	'Philippines':{'countryName':'Philippines','youtubeId':'P-o2qzL-nHo'},
	'Palau':{'countryName':'Palau','youtubeId':'lhjMrKFc6FA'},
	'Papua New Guinea':{'countryName':'Papua New Guinea','youtubeId':'yTuqboqMTfk'},
	'Poland':{'countryName':'Poland','youtubeId':'KQTq07gihqg'},
	'Puerto Rico':{'countryName':'Puerto Rico','youtubeId':'CK9tibAUAn8'},
	'North Korea':{'countryName':'North Korea','youtubeId':'WjV2EErPHdg'},
	'Portugal':{'countryName':'Portugal','youtubeId':'hcArPIarRns'},
	'Paraguay':{'countryName':'Paraguay','youtubeId':'p-59Cb9duyE'},
	'Palestine, State of':{'countryName':'Palestine, State of','youtubeId':'74pxKzFRMFU'}
	,'French Polynesia':{'countryName':'French Polynesia','youtubeId':'3_vcxBe439U'},
	'Qatar':{'countryName':'Qatar','youtubeId':'-VEbDm_mLFM'},
	'Réunion':{'countryName':'Réunion','youtubeId':'V8mo_13cf0Q'},
	'Romania':{'countryName':'Romania','youtubeId':'zTwgwEHiWm0'},
	'Russia':{'countryName':'Russia','youtubeId':'AOAtz8xWM0w'},
	'Rwanda':{'countryName':'Rwanda','youtubeId':'Rdb6CXYCmrA'},
	'Saudi Arabia':{'countryName':'Saudi Arabia','youtubeId':'UeZ-KTx3Mts'},
	'Sudan':{'countryName':'Sudan','youtubeId':'U0R9ozbCfII'},
	'Senegal':{'countryName':'Senegal','youtubeId':'Iq4Z2xPuXRQ'},
	'Singapore':{'countryName':'Singapore','youtubeId':'dgkmw-E2De4'},
	'South Georgia and the South Sandwich Islands':{'countryName':'South Georgia and the South Sandwich Islands','youtubeId':'FxLzVmEPKEE'},
	'Saint Helena, Ascension and Tristan da Cunha':{'countryName':'Saint Helena, Ascension and Tristan da Cunha','youtubeId':'REKA27d6thw'},
	'Svalbard and Jan Mayen':{'countryName':'Svalbard and Jan Mayen','youtubeId':'lk7mhSxMTRE'},
	'Solomon Islands':{'countryName':'Solomon Islands','youtubeId':'NV3ZmZdz3JY'},
	'Sierra Leone':{'countryName':'Sierra Leone','youtubeId':'aLh1xUuCiLM'},
	'El Salvador':{'countryName':'El Salvador','youtubeId':'UnWzKEO6WnM'},
	'San Marino':{'countryName':'San Marino','youtubeId':'ll-wPMWXa3c'},
	'Somalia':{'countryName':'Somalia','youtubeId':'2duoFo9_cxI'},
	'Saint Pierre and Miquelon':{'countryName':'Saint Pierre and Miquelon','youtubeId':'RNEbSi5lDN4'},
	'Serbia':{'countryName':'Serbia','youtubeId':'Wy-Tfhcx-2k'},
	'South Sudan':{'countryName':'South Sudan','youtubeId':'z1Kwcl0zkMs'},
	'Sao Tome and Principe':{'countryName':'Sao Tome and Principe','youtubeId':'5h409WjkAgk'},
	'Suriname':{'countryName':'Suriname','youtubeId':'7ZbIY-vRE0Y'},
	'Slovakia':{'countryName':'Slovakia','youtubeId':'u_Cl5fRPIJc'},
	'Slovenia':{'countryName':'Slovenia','youtubeId':'w-WuhiuEOQc'},
	'Sweden':{'countryName':'Sweden','youtubeId':'j7ZYM3HzeR4'},
	'Eswatini':{'countryName':'Eswatini','youtubeId':'gw3QPXZRwwc'},
	'Sint Maarten (Dutch part)':{'countryName':'Sint Maarten (Dutch part)','youtubeId':'Kg8ibJQBUQ0'},
	'Seychelles':{'countryName':'Seychelles','youtubeId':'07zXhxtodDg'},
	'Syrian Arab Republic':{'countryName':'Syrian Arab Republic','youtubeId':'jy5QYo_K3KA'},
	'Turks and Caicos Islands':{'countryName':'Turks and Caicos Islands','youtubeId':'NyjANMI55b8'},
	'Chad':{'countryName':'Chad','youtubeId':''},'Togo':{'countryName':'Togo','youtubeId':'KL5r4Ga8LX4'},
	'Thailand':{'countryName':'Thailand','youtubeId':'R9RKsT1ed1U'},
	'Tajikistan':{'countryName':'Tajikistan','youtubeId':'3xC3de7FTPM'},
	'Turkmenistan':{'countryName':'Turkmenistan','youtubeId':'TrFq_4wV31w'},
	'Timor-Leste':{'countryName':'Timor-Leste','youtubeId':'IBPplkNd7pA'},
	'Tonga':{'countryName':'Tonga','youtubeId':'UOu4m_uTsc8'},
	'Trinidad and Tobago':{'countryName':'Trinidad and Tobago','youtubeId':'FBywPf6oyFQ'},
	'Tunisia':{'countryName':'Tunisia','youtubeId':'dCjyXk6LiP4'},
	'Turkey':{'countryName':'Turkey','youtubeId':'hWOmuL11g8w'},
	'Taiwan, Province of China':{'countryName':'Taiwan, Province of China','youtubeId':'lvVRecQrHpU'},
	'Tanzania, United Republic of':{'countryName':'Tanzania, United Republic of','youtubeId':'MXpfDhgDKks'},
	'Uganda':{'countryName':'Uganda','youtubeId':'60JphVNLU1s'},
	'Ukraine':{'countryName':'Ukraine','youtubeId':'41Ea6cUt658'},
	'Uruguay':{'countryName':'Uruguay','youtubeId':'CJ2FWYCJWGo'},
	'United States of America':{'countryName':'United States of America','youtubeId':'M1wLtAXDgqg'},
	'Uzbekistan':{'countryName':'Uzbekistan','youtubeId':'y0L8y9l1UVg'},
	'Saint Vincent and the Grenadines':{'countryName':'Saint Vincent and the Grenadines','youtubeId':'rVCQkJabvZQ'},
	'Venezuela':{'countryName':'Venezuela','youtubeId':'39zxCQURiDE'},
	'British Virgin Islands':{'countryName':'British Virgin Islands','youtubeId':'E1XyNbycDRQ'},
	'U.S. Virgin Islands':{'countryName':'U.S. Virgin Islands','youtubeId':'0x0L5JxxAIQ'},
	'Viet Nam':{'countryName':'Viet Nam','youtubeId':'SceSkkRtC2s'},
	'Vanuatu':{'countryName':'Vanuatu','youtubeId':'4x30egUv5as'},
	'Wallis and Futuna':{'countryName':'Wallis and Futuna','youtubeId':'ujMiivQZZEY'},
	'Samoa':{'countryName':'Samoa','youtubeId':'ybOFE0T5V-U'},
	'Yemen':{'countryName':'Yemen','youtubeId':'n-9OGxISfxQ'},
	'South Africa':{'countryName':'South Africa','youtubeId':'NBKjWRjwMkY'},
	'Zambia':{'countryName':'Zambia','youtubeId':'NN6eryOVXnU'},
	'Zimbabwe':{'countryName':'Zimbabwe','youtubeId':'dkg99itp8Nk'}};
	